export enum HomePropertyType {
    SingleFamilyHome,
    MultiFamilyHome,
    Duplex,
    MobileHome,
    Townhome,
    Condominium,
    ManufacturedHome
}

export function homePropertyTypeToValueString(enumValue: HomePropertyType): string {
    switch (enumValue) {
        case HomePropertyType.SingleFamilyHome:
            return "SingleFamilyHome";
        case HomePropertyType.MultiFamilyHome:
            return "MultiFamilyHome";
        case HomePropertyType.Duplex:
            return "Duplex";
        case HomePropertyType.MobileHome:
            return "MobileHome";
        case HomePropertyType.Townhome:
            return "Townhome";
        case HomePropertyType.Condominium:
            return "Condominium";
        case HomePropertyType.ManufacturedHome:
            return "ManufacturedHome";
    }
}

export function homePropertyTypeToDescriptionString(enumValue: HomePropertyType): string {
    switch (enumValue) {
        case HomePropertyType.SingleFamilyHome:
            return "Single Family Home";
        case HomePropertyType.MultiFamilyHome:
            return "Multi Family Home";
        case HomePropertyType.Duplex:
            return "Duplex";
        case HomePropertyType.MobileHome:
            return "Mobile Home";
        case HomePropertyType.Townhome:
            return "Townhome";
        case HomePropertyType.Condominium:
            return "Condominium";
        case HomePropertyType.ManufacturedHome:
            return "Manufactured Home";
    }
}

export enum ResidenceType {
    Own,
    Rent,
    Other,
}

export function residenceTypeToValueString(enumValue: ResidenceType): string {
    switch (enumValue) {
        case ResidenceType.Own:
            return "Own";
        case ResidenceType.Rent:
            return "Rent";
        case ResidenceType.Other:
            return "Other";
    }
}

export function residenceTypeToDescriptionString(enumValue: ResidenceType): string {
    return residenceTypeToValueString(enumValue);
}

export enum GenderType {
    Female,
    Male,
    Nonbinary,
}

export function genderTypeToValueString(enumValue: GenderType): string {
    switch (enumValue) {
        case GenderType.Female:
            return "Female";
        case GenderType.Male:
            return "Male";
        case GenderType.Nonbinary:
            return "Nonbinary";
    }
}

export function genderTypeToDescriptionString(enumValue: GenderType): string {
    return genderTypeToValueString(enumValue);
}

export enum AutoDriverLicenseStatus {
    Active,
    Suspended,
    Probation,
    Restricted,
    Learner,
    Temporary,
    International
}

export function autoDriverLicenseStatusToValueString(enumValue: AutoDriverLicenseStatus): string {
    switch (enumValue) {
        case AutoDriverLicenseStatus.Active:
            return "Active";
        case AutoDriverLicenseStatus.Suspended:
            return "Suspended";
        case AutoDriverLicenseStatus.Probation:
            return "Probation";
        case AutoDriverLicenseStatus.Restricted:
            return "Restricted";
        case AutoDriverLicenseStatus.Learner:
            return "Learner";
        case AutoDriverLicenseStatus.Temporary:
            return "Temporary";
        case AutoDriverLicenseStatus.International:
            return "International";
    }
}

export function autoDriverLicenseStatusToDescriptionString(enumValue: AutoDriverLicenseStatus): string {
    return autoDriverLicenseStatusToValueString(enumValue);
}

export enum InsuredSinceLength {
    LessThanSixMonths,
    SixMonths,
    OneYear,
    TwoYears,
    ThreeYears,
    ThreeToFiveYears,
    MoreThanFiveYears
}

export function insuredSinceLengthToValueString(enumValue: InsuredSinceLength): string {
    switch (enumValue) {
        case InsuredSinceLength.LessThanSixMonths:
            return "LessThanSixMonths";
        case InsuredSinceLength.SixMonths:
            return "SixMonths";
        case InsuredSinceLength.OneYear:
            return "OneYear";
        case InsuredSinceLength.TwoYears:
            return "TwoYears";
        case InsuredSinceLength.ThreeYears:
            return "ThreeYears";
        case InsuredSinceLength.ThreeToFiveYears:
            return "ThreeToFiveYears";
        case InsuredSinceLength.MoreThanFiveYears:
            return "MoreThanFiveYears";
    }
}

export function insuredSinceLengthToDescriptionString(enumValue: InsuredSinceLength): string {
    switch (enumValue) {
        case InsuredSinceLength.LessThanSixMonths:
            return "Less Than Six Months";
        case InsuredSinceLength.SixMonths:
            return "Six Months";
        case InsuredSinceLength.OneYear:
            return "One Year";
        case InsuredSinceLength.TwoYears:
            return "Two Years";
        case InsuredSinceLength.ThreeYears:
            return "Three Years";
        case InsuredSinceLength.ThreeToFiveYears:
            return "Three To Five Years";
        case InsuredSinceLength.MoreThanFiveYears:
            return "More Than Five Years";
    }
}

export enum CreditType {
    Poor,
    Average,
    Good,
    Excellent,
}

export function creditTypeToValueString(enumValue: CreditType): string {
    switch (enumValue) {
        case CreditType.Poor:
            return "Poor";
        case CreditType.Average:
            return "Average";
        case CreditType.Good:
            return "Good";
        case CreditType.Excellent:
            return "Excellent";
    }
}

export function creditTypeToDescriptionString(enumValue: CreditType): string {
    return creditTypeToValueString(enumValue);
}